import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";

export default function AboutPoint() {
  return (
    <>
    <section className="aboutpage-point">
        <div className="container">

            <div className="row align-items-center aboutpoint-row">  
                <div className="col-lg-5 col-md-5 order-2 order-lg-1 order-md-1">
                    <div className="aboutpoint-imageleft">
                        <img src="/image/aboutpoint-2.webp" loading="lazy" className="img-responsive" alt="about"/>
                    </div>
                </div>

                <div className="col-lg-7 col-md-7 order-1 order-lg-2 order-md-2">
                    <div className="aboutpoint-detail wow animate__animated animate__slideInUp" data-wow-duration="1.4s" data-wow-delay="0.2s">
                        <span>01.</span>
                        <p className="mb-0">We ask the right questions and build meaningful relationships that reveal how our clients want their spaces to function, feel, and live. This approach is both intentional and intuitive - a balance of desires, styles, and lifestyles that guides every piece we craft and every project we execute.</p>
                    </div>
                </div>
            </div>

            <div className="row align-items-center">  
                <div className="col-lg-7 col-md-7">
                    <div className="aboutpoint-detail wow animate__animated animate__slideInUp" data-wow-duration="1.4s" data-wow-delay="0.2s">
                        <span>02.</span>
                        <p>It is an honor to bring beauty, precision, and meaning to every home, estate, or hospitality space. That’s why organization, communication, problem-solving, efficiency, and attention to detail are central to our process. The result is more than a finished interior; it is the joy of seeing ideas transformed into reality and knowing we’ve contributed to a client’s story.</p>
                        <Link to="/project" className="arrow-button">View All Work <Icons name="Longarrow_right"/></Link>
                    </div>
                </div>

                <div className="col-lg-5 col-md-5">
                    <div className="aboutpoint-image">
                        <img src="/image/aboutpoint.webp" loading="lazy" className="img-responsive" alt="about"/>
                    </div>
                </div>
            </div>

        </div>
    </section>
    </>
  )
}
